import { InfoIconCR } from '~/icons';
import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';
import { BoxSendingInfoMachine } from '../styles';
import { Loader } from '~/components/Loader';

interface ModalSendingConfigs {
  isOpen: boolean;
  onClose: () => void;
}

export const ModalSendingConfigs: React.FC<ModalSendingConfigs> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      centralizedText
      imageText={(
        <BoxSendingInfoMachine>
          {t('configuracoesSendoEnviadas')}
          <div>
            <InfoIconCR />
            {t('esteProcessoPodeLevarAlgunsInstantes')}
          </div>
          <Loader />
        </BoxSendingInfoMachine>
      )}
      removeXCloseButton
    />
  );
};
